import type { RouteRecordRaw } from 'vue-router';

export const CHANNEL_INQUIRY_ROUTER: RouteRecordRaw[] = [
  {
    path: '/sales/channel-inquiry',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/sales/channel-inquiry/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/sales/channelInquiry/views/List.vue'),
        name: 'Channel Inquiry List',
        meta: {
          title: '채널별 매출조회',
        },
      },
    ],
  },
];
